export default {"src":"/_next/static/media/HelpIcon.84d61d38.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};